export const fieldMapping = {
    0: {
        hbl: 'oimHblUpdateForm',
        cntr: 'oimContainerUpdateForm',
        split: 'oimContainerAliasUpdateForm',
        statusMessage: 'oimStatusUpdateForm',
        mainId: 'il_ocean_import_id',
        hblId: 'il_ocean_import_hbl_id',
        cntrId: 'il_ocean_import_cntr_id',
    },
    1: {
        hbl: 'oexHblUpdateForm',
        cntr: 'oexContainerUpdateForm',
        split: null,
        statusMessage: 'oexStatusUpdateForm',
        mainId: 'il_ocean_export_id',
        hblId: 'il_ocean_export_hbl_id',
    },
    2: {
        hbl: 'aimHblUpdateForm',
        cntr: 'aimContainerUpdateForm',
        split: null,
        statusMessage: 'aimStatusUpdateForm',
        mainId: 'il_air_import_id',
        hblId: 'il_air_import_hbl_id',
    },
    3: {
        hbl: 'aexHblUpdateForm',
        cntr: 'aexContainerUpdateForm',
        split: null,
        statusMessage: 'aexStatusUpdateForm',
        mainId: 'il_air_export_id',
        hblId: 'il_air_export_hbl_id',
    },
    4: {
        hbl: 'truckingBolUpdateForm',
        cntr: null,
        split: null,
        statusMessage: 'truckingStatusUpdateForm',
        mainId: 'il_ftl_ltl_id',
        hblId: 'il_ftl_ltl_id',
    },
};
